export type CourseRoleId =
  | 'SOFTWARE_ENGINEER'
  | 'DATA_SCIENCE'
  | 'UXUI_DESIGNER'
  | 'PRODUCT_PROJECT_MANAGER'
  | 'BUSINESS_MANAGEMENT'
  | 'DIGITAL_MARKETING'
  | 'CYBERSECURITY'
  | 'SALES_ACCOUNT_MANAGEMENT'
  | 'CONSULTING_SYSTEM_INTEGRATION'
  | 'IT_SUPPORT'
  | 'NETWORKING_SYSTEM_ADMIN'
  | 'GRAPHIC_DESIGN'
  | 'MULTIMEDIA'
  | 'TECHNICAL_WRITING'
  | 'OTHERS'

export const courseRoles: {
  title: string
  id: CourseRoleId
}[] = [
  {
    id: 'SOFTWARE_ENGINEER',
    title: 'Software Engineer'
  },
  {
    id: 'DATA_SCIENCE',
    title: 'Data Science'
  },
  {
    id: 'UXUI_DESIGNER',
    title: 'UX/UI Designer'
  },
  {
    id: 'PRODUCT_PROJECT_MANAGER',
    title: 'Product/Project Manager'
  },
  {
    id: 'BUSINESS_MANAGEMENT',
    title: 'Business Management'
  },
  {
    id: 'DIGITAL_MARKETING',
    title: 'Digital Marketing'
  },
  {
    id: 'CYBERSECURITY',
    title: 'Cybersecurity'
  },
  {
    id: 'SALES_ACCOUNT_MANAGEMENT',
    title: 'Sales/Account Management'
  },
  {
    id: 'CONSULTING_SYSTEM_INTEGRATION',
    title: 'Consulting/System Integration'
  },
  {
    id: 'IT_SUPPORT',
    title: 'IT Support'
  },
  {
    id: 'NETWORKING_SYSTEM_ADMIN',
    title: 'Networking/System Admin'
  },
  {
    id: 'GRAPHIC_DESIGN',
    title: 'Graphic Design'
  },
  {
    id: 'MULTIMEDIA',
    title: 'Multimedia'
  },
  {
    id: 'TECHNICAL_WRITING',
    title: 'Technical Writing'
  },
  {
    id: 'OTHERS',
    title: 'Others'
  }
]
